import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    ArrowLeft,
    Loader2,
} from "lucide-react";

import {
    getCustomer,
} from "../services/adminApi";

import CustomerProfileCard from "../components/customer/CustomerProfileCard";
import CustomerStatsCard from "../components/customer/CustomerStatsCard";
import SavedAddressesCard from "../components/customer/SavedAddressesCard";
import OrderHistoryCard from "../components/customer/OrderHistoryCard";
import FavouriteFoodsCard from "../components/customer/FavouriteFoodsCard";
import ReviewsCard from "../components/customer/ReviewsCard";
import CustomerActionButtons from "../components/customer/CustomerActionButtons";

import "./CustomerDetails.css";

function CustomerDetails() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [customerData, setCustomerData] = useState(null);

    const [loading, setLoading] = useState(true);

    const loadCustomer = async () => {

        try {

            setLoading(true);

            const res = await getCustomer(id);

            setCustomerData(res.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadCustomer();

    }, [id]);

    if (loading) {

        return (

            <div className="customer-details-loading">

                <Loader2 size={45} className="spin" />

                <h2>Loading Customer...</h2>

            </div>

        );

    }

    if (!customerData) {

        return (

            <div className="customer-details-loading">

                <h2>Customer Not Found</h2>

            </div>

        );

    }

    const {

        customer,
        statistics,
        orders,
        reviews,
        addresses,
        favouriteFoods,

    } = customerData;

    return (

        <div className="customer-details-page">
<div className="customer-details-header">

    <button
        className="back-btn"
        onClick={() => navigate(-1)}
    >
        <ArrowLeft size={18} />
        Back
    </button>

    <div>

        <h1>Customer Details</h1>

        <p>
            Complete customer profile, orders and activity.
        </p>

    </div>

</div>

            <CustomerProfileCard
                customer={customer}
            />

            <CustomerStatsCard
                statistics={statistics}
            />

           <div className="customer-section-grid">

    <SavedAddressesCard
        addresses={addresses}
    />

    <OrderHistoryCard
        orders={orders}
    />

</div>

<div className="customer-section-grid">

    <FavouriteFoodsCard
        favouriteFoods={favouriteFoods}
    />

    <ReviewsCard
        reviews={reviews}
    />

</div>

            <CustomerActionButtons
                customer={customer}
                reload={loadCustomer}
            />

        </div>

    );

}

export default CustomerDetails;